import { useCallback, useState } from 'react';
import { useResponsive } from '../context/ResponsiveContext';
import {
  dismissBrowserRecommendation,
  isBrowserRecommendationDismissed,
  shouldShowBrowserRecommendation,
} from '../utils/browserRecommendation';

/**
 * Controls browser recommendation banner visibility and layout offset CSS variable.
 */
export function useBrowserRecommendation() {
  const { isMobile: isMobileViewport } = useResponsive();
  const [dismissed, setDismissed] = useState(() => isBrowserRecommendationDismissed());

  const visible = !dismissed && shouldShowBrowserRecommendation(isMobileViewport);

  const dismiss = useCallback(() => {
    dismissBrowserRecommendation();
    setDismissed(true);
  }, []);

  return { visible, dismiss, isMobileViewport };
}

export default useBrowserRecommendation;
